// src/components/hr/GetCertified.js
import { useEffect, useRef, useState, useContext } from "react";
import axios from "axios";
import Utils from "../Utils";
import UserContext from "../contexts/UserContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../scormApi"; // IMPORTANT: just import once to register API
import _ from "lodash";
const MySwal = withReactContent(Swal);

const GetCertified = () => {
  const { initUserData, userData } = useContext(UserContext);
  const iframeRef = useRef(null);
  const completedOnceRef = useRef(false);
  const [language, setLanguage] = useState(false);
  //const SCORM_URL = `${process.env.PUBLIC_URL}/scormfiles/${userData?.isHR ? "scorm" : "scorm"}/index_lms.html`;

  const getScormUrl = () => {
    let url = process.env.REACT_APP_COURSE_FOLDER;
    if (userData?.isPG) {
      url += "/catpuring-it-right";
    } else {
      url += "/apec-photography-process";
    }
    return url + `-${language}/story.html`;
  };

  const COURSE_ID = userData?.isHR ? 1 : 2; // example: 1 for HR, 2 for PG

  /* -------- Restore Resume BEFORE launch -------- */
  // useEffect(() => {
  //   axios
  //     .get(Utils.apiUrl(`scorm/progress/${COURSE_ID}`))
  //     .then((res) => {
  //       const data = res.data;
  //       if (!data) return;
  //       // ...existing code...
  //     })
  //     .catch(() => {});
  //   // For now, just log a placeholder
  //   console.log("SCORM_RESUME", JSON.stringify({ courseId: COURSE_ID, version: "SCORM_2004", location: "", suspendData: "" }, null, 2));
  // }, []);

  /* -------- Listen to SCORM events -------- */

  useEffect(() => {
    const onProgress = (e) => {
      // axios.post(Utils.apiUrl("scorm/progress"), {
      //   courseId: COURSE_ID,
      //   ...e.detail,
      // });
      console.log(
        "SCORM_PROGRESS",
        JSON.stringify({ courseId: COURSE_ID, ...e.detail }, null, 2),
      );
    };

    const onCompleted = async (e) => {
      const detail = e.detail;
      console.log(
        "SCORM_COMPLETED",
        JSON.stringify({ courseId: COURSE_ID, ...detail }, null, 2),
      );
      // Guard: prevent duplicate API calls
      if (completedOnceRef.current) return;

      // Condition check
      if (detail.completed === true && detail.status === "passed") {
        completedOnceRef.current = true;

        certifyUser();
      }
    };

    //console.log("SCORM_COMPLETED", JSON.stringify({ courseId: COURSE_ID, ...e.detail }, null, 2));
    window.addEventListener("SCORM_PROGRESS", onProgress);
    window.addEventListener("SCORM_COMPLETED", onCompleted);

    return () => {
      window.removeEventListener("SCORM_PROGRESS", onProgress);
      window.removeEventListener("SCORM_COMPLETED", onCompleted);
    };
  }, []);

  useEffect(() => {
    const onMessage = (event) => {
      //if (event.origin !== "https://auraphotosblob.blob.core.windows.net") return;

      const data = event.data;
      if (data?.type !== "SCORM_COMPLETED") return;

      if (completedOnceRef.current) return;

      if (
        data.completed === true &&
        (data.status === "completed" ||
          data.status === "passed" ||
          data.success === "passed")
      ) {
        completedOnceRef.current = true;
        certifyUser();
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  const certifyUser = () => {
    const formData = new FormData();
    formData.append("course_id", 1); // backend expects numeric ID

    axios
      .post(Utils.apiUrl("frontend/auth/certify"), formData, Utils.apiHeaders())
      .then((res) => {
        if (res.data?.success) {
          res.data.userData.certsucc = true;
          initUserData(res.data);
          MySwal.fire({
            title: "Congratulations!",
            text: "Certification recorded successfully.",
            icon: "success",
            buttonsStyling: false,
            customClass: {
              popup: "rounded-xl",
              confirmButton:
                "bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded",
            },
          }).then(() => {
            window.location.href = "/dashboard";
          });
        }
      })
      .catch(() => {
        MySwal.fire({
          title: "Error",
          text: "Failed to record certification.",
          icon: "error",
          buttonsStyling: false,
          customClass: {
            popup: "rounded-xl",
            confirmButton:
              "bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded",
          },
        });
      });
  };

  window["certifyUser"] = certifyUser; // for testing

  const languagesAry = {
    en: {
      name: "English",
      local: "English",
      onClick: () => setLanguage("en"),
    },
    jp: {
      name: "Japanese",
      local: "日本語",
      onClick: () => comingSoon("Japanese"),
    },
    ko: {
      name: "Korean",
      local: "한국어",
      onClick: () => comingSoon("Korean"),
    },
    vn: {
      name: "Vietnamese",
      local: "Tiếng Việt",
      onClick: () => comingSoon("Vietnamese"),
    },
  };

  const comingSoon = (lang) => {
    MySwal.fire({
      title: "Coming Soon",
      text: `The ${lang.toUpperCase()} version is coming soon!`,
      icon: "info",
      buttonsStyling: false,
      customClass: {
        popup: "rounded-xl",
        confirmButton:
          "bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded",
      },
    });
  };

  return (
    <main className="container mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-6">Get Certified</h1>
      {/* replce onclick actual course progress => onClick={() => setStarted(true)} */}
      {language === false && (
        <div className=" bg-white p-10 rounded-xl shadow-md text-center  ">
          <h1 className="text-2xl font-semibold mb-4 mb-10">
            Click your preferred language to start the certification process
          </h1>
          <div className="text-blue-400 text-2xl font-semibold">
            {_.map(languagesAry, (lang, code) => (
              <>
                <span
                  key={code}
                  onClick={lang.onClick}
                  className="cursor-pointer px-4 hover:text-blue-600 hover:underline"
                  title={`Click to select ${lang.name}`}
                >
                  {lang.local}
                </span>
                {code !== _.last(_.keys(languagesAry)) && (
                  <span className="text-gray-900"> | </span>
                )}
              </>
            ))}
          </div>
        </div>
      )}

      {language !== false && (
        <iframe
          ref={iframeRef}
          src={getScormUrl()}
          title="SCORM Player"
          style={{ width: "100%", height: "100vh", border: "none" }}
          allow="fullscreen"
        />
      )}
    </main>
  );
};

export default GetCertified;
